export const CAMPTON_KLASS = 'mshop_campton_klass';
